import script from "./IngresarOpciones.vue?vue&type=script&setup=true&lang=js"
export * from "./IngresarOpciones.vue?vue&type=script&setup=true&lang=js"

import "./IngresarOpciones.vue?vue&type=style&index=0&id=82fc0b16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82fc0b16"]])

export default __exports__